export default __webpack_public_path__ + "static/media/caret-down-blue.9397d8ae.svg";